import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from "react-redux";
import Modal from "modal-enhanced-react-native-web";
import { colors, action } from "../../const";
import { FONT_REGULAR } from "../../const/Global";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons"
import localize from "../../localize";

export default function RecordExceptionDialog() {
    const dispatch = useDispatch();
    const isVisible = useSelector(({ setting }) => setting.isRecordException);

    const onClose = () => {
        dispatch({ type: action.RECORD_EXCEPTION_FALSE });
    }

    return (
        <Modal
            isVisible={isVisible}
            onDismiss={onClose}
            onBackdropPress={onClose}
            transparent={true}
            backdropOpacity={0.4}
        >
            <View
                style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}
            >

                <View style={{ minWidth: 320, maxWidth: 375 }}>
                    <View style={PageStyles.modalContainer}>
                        <TouchableOpacity
                            style={PageStyles.close}
                            onClick={onClose}
                        >
                            <Icon
                                icon={faTimes}
                                size="1x"
                                color={colors.midnightBack}
                            />
                        </TouchableOpacity>

                        <View style={{ alignItems: "center" }}>
                            <Icon
                                icon={faExclamationTriangle}
                                size="5x"
                                color={colors.alert}
                                style={{
                                    position: "static",
                                    marginTop: 20,
                                    marginBottom: 20
                                }}
                            />
                            <View style={PageStyles.container}>
                                <Text style={PageStyles.header}>
                                    {localize.Unable_to_access_microphone}
                                </Text>
                                <Text style={PageStyles.desc}>
                                    {localize.If_you_are_getting_the_error}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </Modal>
    )
}

const PageStyles = StyleSheet.create({
    modalContainer: {
        backgroundColor: '#FFF',
        borderRadius: 6,
        minHeight: 300
    },
    close: {
        padding: 10,
        right: 10,
        top: 0,
        alignSelf: "flex-end"
    },
    container: {
        alignSelf: "center",
        margin: 10,
        paddingHorizontal: 10
    },
    header: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        fontFamily: FONT_REGULAR,
        color: colors.midnightBack,
        paddingVertical: 5,
    },
    desc: {
        fontFamily: FONT_REGULAR,
        color: colors.midnightBack,
        paddingVertical: 5,
        fontSize: 13,
        textAlign: "left"
    },
})
